<template>
	<div class="inputContentBox">
		<yd-cell-group>
			<span class="title">{{title}}</span>
			<yd-cell-item arrow>
				<yd-datetime
					ref="datetime"
					type="date"
					:init-emit="false"
					v-model="inputStr"
					:start-date="start"
					:end-date="end"
					:readonly="changeAble"
					slot="right"
				></yd-datetime>
			</yd-cell-item>
		</yd-cell-group>
		<div class="tip" v-if="!this.inputStr" @click="changeShow()">{{text}}</div>
	</div>
</template>

<script>
	export default {
		name: "inputComponent",
		props: ["title", "text", "start", "end", "value", "changeAble"],
		data() {
			return {
				isShow: false
			};
		},
		computed: {
			inputStr: {
				get: function () {
					return this.value;
				},
				set: function (val) {
					this.$emit("input", val);
				}
			}
		},
		methods: {
			changeShow: function () {
				if (!this.changeAble) {
					this.$refs.datetime.open();
				}
			},
			checkSubmit: function () {
				if (!this.inputStr) {
					this.$common.errTip("请选择" + this.title);
					return false;
				}
				return true;
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/inputComponent/dateComponent.vue